import { render, staticRenderFns } from "./template-email-modal.vue?vue&type=template&id=079d9ca7"
import script from "./template-email-modal.vue?vue&type=script&lang=js"
export * from "./template-email-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports